// projects/humanresources-common-shared/assets/i18n/*/hr-common.json
export class HrCommonKey {
    private static readonly keyPrefix = 'hrCommon';
    public static listTitle = `${HrCommonKey.keyPrefix}.listTitle`;
    public static addTitle = `${HrCommonKey.keyPrefix}.addTitle`;
    public static editTitle = `${HrCommonKey.keyPrefix}.editTitle`;
    public static copyTitle = `${HrCommonKey.keyPrefix}.copyTitle`;
    public static removeTitle = `${HrCommonKey.keyPrefix}.removeTitle`;
    public static searchTitle = `${HrCommonKey.keyPrefix}.searchTitle`;
    public static beginDate = `${HrCommonKey.keyPrefix}.beginDate`;
    public static endDate = `${HrCommonKey.keyPrefix}.endDate`;
    public static type = `${HrCommonKey.keyPrefix}.type`;
    public static country = `${HrCommonKey.keyPrefix}.country`;
    public static province = `${HrCommonKey.keyPrefix}.province`;
    public static subProvince = `${HrCommonKey.keyPrefix}.subProvince`;
    public static rank = `${HrCommonKey.keyPrefix}.rank`;
    public static time = `${HrCommonKey.keyPrefix}.time`;
    public static content = `${HrCommonKey.keyPrefix}.content`;
    public static explanation = `${HrCommonKey.keyPrefix}.explanation`;
    public static startDate = `${HrCommonKey.keyPrefix}.startDate`;
    public static code = `${HrCommonKey.keyPrefix}.code`;
    public static shortText = `${HrCommonKey.keyPrefix}.shortText`;
    public static longText = `${HrCommonKey.keyPrefix}.longText`;
    public static status = `${HrCommonKey.keyPrefix}.status`;
    public static text = `${HrCommonKey.keyPrefix}.text`;
    public static queryCriteria = `${HrCommonKey.keyPrefix}.queryCriteria`;
    public static Name = `${HrCommonKey.keyPrefix}.name`;
    public static surname = `${HrCommonKey.keyPrefix}.surname`;
    public static statuses = `${HrCommonKey.keyPrefix}.statuses`;
    public static booleanTrue = `${HrCommonKey.keyPrefix}.booleanTrue`;
    public static booleanFalse = `${HrCommonKey.keyPrefix}.booleanFalse`;
    public static blockMessage = `${HrCommonKey.keyPrefix}.blockMessage`;
    public static unblockMessage = `${HrCommonKey.keyPrefix}.unblockMessage`;
    public static dataApprovalStatus = `${HrCommonKey.keyPrefix}.dataApprovalStatus`;
    public static confirmationHeader = `${HrCommonKey.keyPrefix}.confirmationHeader`;
    public static timeConstraintDateConflictConfirmationMessage = `${HrCommonKey.keyPrefix}.timeConstraintDateConflictConfirmationMessage`;

}
